import React from 'react';

import { Person as PersonIcon } from '@mui/icons-material';

import { Button } from '@mui/material';

import Tile from '../../../../common/components/Tile/Tile';
import TableEnhancedContainer from '../../../../common/components/TableEnhanced/TableEnhancedContainer';
import EditUserContainer from './EditUser/EditUserContainer.js';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';

const UsersAccounts = (props) => (
  <Tile
    title="User accounts"
    TitleIcon={PersonIcon}
    helpTag="user_accounts"
    RightContent={
      <div>
        <PermissionsCheck permission={PermissionsEnum.EDIT_USERS}>
          <Button
            variant="contained"
            data-qa="qa-addNewUser"
            className="u-ml-double"
            color="primary"
            onClick={() => props.openAddUser('')}
          >
            Add
          </Button>
        </PermissionsCheck>
        <EditUserContainer {...props} />
      </div>
    }
  >
    <TableEnhancedContainer
      {...props}
      className="UsersAccountsTable"
      enableHideColumns={true}
      enableActionButtons={true}
    />
  </Tile>
);

export default UsersAccounts;
